const updateDiscount = (state, action) => {
  if (state === undefined) {
    return {
      discount: [],
      discountLoading: true,
      invoiceDiscount: {},
      invoice: {},
      invoices: [],
      invoicesLoading: true,
      changeStatusTraining: false,
      state_invoice: {},
      modalLoading: false,
    };
  }

  switch (action.type) {
   case 'DISCOUNT_LOADING': {
     return  {
         ...state.discount,
         modalLoading: action.payload
      }
    }
    case "DISCOUNT_REQUESTED":
      return {
        ...state.discount,
        discountLoading: true,
      };
    case "DISCOUNT_LOADED":
      return {
        ...state.discount,
        discountLoading: false,
        discount: action.payload,
      };
    case "INVOICE_LOADED":
      return {
        ...state.discount,
        invoiceDiscount: action.payload,
      };
    case "INVOICES_LOADING":
      return {
        ...state.discount,
        invoicesLoading: action.payload,
      };
    case "INVOICES_REQUEST":
      return {
        ...state.discount,
        invoices: action.payload,
      };
    case "INVOICE_DATA_REQUEST":
      return {
        ...state.discount,
        invoice: action.payload,
        changeStatusTraining: false,
      };
    case "STATE_INVOICE":
      return {
        ...state.discount,
        state_invoice: action.payload,
      };
    case "CHANGE_STATUS_TRAINING":
      return {
        ...state.discount,
        changeStatusTraining: true,
      };
    case "DISCOUNT_ERROR":
      return {
        ...state.discount,
        discount: [],
        discountLoading: false,
        error: action.payload,
      };
    case "UPDATE_DISCOUNT":
      return {
        ...state.discount,
        discount: action.payload,
      };

    default:
      return state.discount;
  }
};

export default updateDiscount;
